import { render, staticRenderFns } from "./AdminPage_New.vue?vue&type=template&id=2865807f&scoped=true"
import script from "./AdminPage_New.vue?vue&type=script&lang=js"
export * from "./AdminPage_New.vue?vue&type=script&lang=js"
import style0 from "./AdminPage_New.vue?vue&type=style&index=0&id=2865807f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865807f",
  null
  
)

export default component.exports